import './FansSummary.sass';

import { FC, useMemo } from 'react';

import { useTranslator } from '$hooks';
import { CurrencyEnum } from '$store/models';

import { FansSummary as FansSummaryData } from '../StatisticsProFans.types';

const countFormatter = new Intl.NumberFormat('en-US');

export interface FansSummaryProps {
  summary: FansSummaryData;
  currency: CurrencyEnum;
}

export const FansSummary: FC<FansSummaryProps> = ({ summary, currency }) => {
  const t = useTranslator();
  const ccy = currency.toUpperCase();

  const moneyFormatter = useMemo(() => {
    const fractionDigits = currency === CurrencyEnum.PLACE ? 0 : 2;
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    });
  }, [currency]);

  return (
    <div className="FansSummary">
      <div className="FansSummary__item">
        <div className="FansSummary__value">
          {countFormatter.format(summary.fanCount)}
        </div>
        <div className="FansSummary__label">
          {t('statistics_pro_fans_summary_fans', { defaultValue: 'Paying fans' })}
        </div>
      </div>
      <div className="FansSummary__item">
        <div className="FansSummary__value">
          {moneyFormatter.format(summary.totalAmount)} {ccy}
        </div>
        <div className="FansSummary__label">
          {t('statistics_pro_total', { defaultValue: 'Total' })}
        </div>
      </div>
    </div>
  );
};
